module.exports = __webpack_public_path__ + "static/media/15a.18b8cc29.ogg";